import request from "@/utils/request";

let MerchApi = {
    /*首页概况*/
    index(data, errorback) {
        return request._get("/merch/cash.cash/index", data, errorback);
    },
    /*获取用户提现账户信息*/
    getAccount(data, errorback) {
        return request._get("/merch/cash.cash/account", data, errorback);
    },
    /*保存用户提现账户信息*/
    setAccount(data, errorback) {
        return request._post("/merch/cash.cash/account", data, errorback);
    },
    /*提现记录*/
    lists(data, errorback) {
        return request._post("/merch/cash.cash/lists", data, errorback);
    },
    /*申请提现*/
    apply(data, errorback) {
        return request._post("/merch/cash.cash/apply", data, errorback);
    },
    /* 店铺结算*/
    settled(data, errorback) {
        return request._post("/merch/cash.settled/index", data, errorback);
    },
    /* 店铺结算详情*/
    detail(data, errorback) {
        return request._post("/merch/cash.settled/detail", data, errorback);
    },
    /*退保证金*/
    refund(data, errorback) {
        return request._post("/merch/merch.merch/refund", data, errorback);
    }
};

export default MerchApi;



// WEBPACK FOOTER //
// ./src/api/cash.js